import { useEffect, useState, useContext } from 'react';
import { CatalogContext } from './Catalog.context';

export default function Scaler({ children, className }) {
  const { width, height, isResponsiveMode } = useContext(CatalogContext);
  const getScale = () => {
    const deltaRatio = width / height;
    const windowRatio = window.innerWidth / window.innerHeight;

    return windowRatio <= deltaRatio
      ? window.innerWidth / width
      : window.innerHeight / height;
  };
  const getStyle = scaleRatio => {
    let style = {};

    if (!isResponsiveMode) {
      style = {
        '--width': `${width}px`,
        '--height': `${height}px`,
        transform: `scale(${scaleRatio})`,
      };
    } else {
      style = {
        '--width': `100%`,
        '--height': `auto`,
        transform: `none`,
      };
    }

    return style;
  };

  const [scaleRatio, setScaleRatio] = useState(getScale());
  useEffect(() => {
    const resizeHandler = () => setScaleRatio(getScale());
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [isResponsiveMode]);

  const [style, setStyle] = useState(getStyle(scaleRatio));
  useEffect(() => {
    setStyle(getStyle(scaleRatio));
  }, [scaleRatio, isResponsiveMode]);

  return (
    <div
      className={className}
      style={style}
    >
      {children}
    </div>
  );
}
